import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';

import { useFormCreateFuelType } from '../../controllers/FuelType/CreateFuelTypeController';
import LoadingScreen from '../../components/LoadingScreen';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const FuelTypeForm: React.FC = () => {
    const { getFuelFormController, handleFuelFormController } = useFormCreateFuelType();
    const history = useHistory();

    const [registerFinished, setRegisterFinished] = useState(false);

    useEffect(() => {
        if (getFuelFormController.fuelResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getFuelFormController.fuelEditedResponse?.status === 200 && !getFuelFormController.fuelResponse) {
            setRegisterFinished(false);
        }
    }, [getFuelFormController.fuelResponse, getFuelFormController.fuelEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getFuelFormController.toast} />
            {getFuelFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Tipo de combustivel</h5>
                    <div className="p-field">
                        <label htmlFor="name">Nome</label>
                        <InputText id="name" type="text" disabled={registerFinished}
                            value={getFuelFormController.formik.values.DESCRICAO}
                            onChange={getFuelFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getFuelFormController.formik.touched.DESCRICAO && getFuelFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getFuelFormController.formik.touched.DESCRICAO && getFuelFormController.formik.errors.DESCRICAO),
                        })}
                        >{getFuelFormController.formik.errors.DESCRICAO}</div>
                    </div>
                    <div className="p-fluid p-grid p-justify-between">
                        {getFuelFormController.fuelResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getFuelFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getFuelFormController.fuelResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getFuelFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleFuelFormController.setFuelResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getFuelFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FuelTypeForm;